(() => {
  /**
   * Terminology:
   * - Bundle product: a combination of 2 products with a single price
   * - Bundled product: the second product of the bundle product (based on current page's product)
   *
   * Notes:
   * - This file is intend to be used for both 'rw_bundle_selector' and 'wr_bundle_selector', so keep all of the functions re-usable
   * - For bundle product, the handle will always start with washer followed by laundry rack
   * - example: typhoon-wt-85-white-solaris-white-pearl
   * - format: {washer}-{washerColour}-{rack}-{rackColour}
   */

  // update all handles for bundle product
  // reason: bundle product has rack sizes whereas the rack product does not
  $(".washer_rack_bundle_selector .bundle-product-select option").each(
    function (_, option) {
      const title = $(option).attr("data-title");
      const newTitle = title.replace(/\s*\([^)]*\)/g, "");
      const newHandle = theme.handleize(newTitle);
      $(option).attr("data-handle", newHandle);
    },
  );

  // handle addon selection
  $(".washer_rack_bundle_selector .bundled-product").on("click", function () {
    $(this).toggleClass("selected");
    $(".bundle-product-select").change(); // trigger onchange event to update date in '#currentVariant'
  });

  // handle clicks on '.item'
  $(".washer_rack_bundle_selector .item").on("click", function (event) {
    event.stopPropagation();
    $(this).siblings(".item").removeClass("active");
    $(this).addClass("active");

    $(this)
      .closest(".product-selector")
      .find("label .sel")
      .text($(this).text());
  });
})();
